module.exports = __webpack_public_path__ + "static/media/Alexander-Lettering.35bf44d0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Alexander-Lettering.woff2
// module id = 3013
// module chunks = 70